/** Recherche + filtre inactifs. */
import "../clients/clientListBar.css";
import { SearchClear } from "../../components/SearchClear";

type CatalogListBarProps = {
  q: string;
  onQ: (v: string) => void;
  showInactive: boolean;
  onShowInactive: (v: boolean) => void;
  count?: number;
};

export function CatalogListBar({ q, onQ, showInactive, onShowInactive, count }: CatalogListBarProps) {
  return (
    <div className="fx-listbar">
      <label className="fx-listbar__search">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="10.5" cy="10.5" r="6.2" stroke="currentColor" strokeWidth="1.7" />
          <path d="M15.2 15.2 20 20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
        <input
          className="fx-listbar__input"
          name="q"
          value={q}
          placeholder="Libellé, code ou descriptif"
          autoComplete="off"
          aria-label="Rechercher un produit"
          onChange={(e) => onQ(e.target.value)}
        />
        <SearchClear value={q} onClear={() => onQ("")} />
      </label>
      <button
        type="button"
        className={`fx-listbar__toggle${showInactive ? " is-on" : ""}`}
        aria-pressed={showInactive}
        onClick={() => onShowInactive(!showInactive)}
      >
        <span className="fx-listbar__dot" aria-hidden="true" />
        Inactifs
      </button>
      {typeof count === "number" ? (
        <span className="fx-listbar__count">
          {count} produit{count === 1 ? "" : "s"}
        </span>
      ) : null}
    </div>
  );
}
